import React, {useState} from "react";
import {useSearchParams} from "react-router-dom";
import {Card, Col, Divider, Empty, Image, Row, Space, Tooltip, Typography} from "antd";
import {VscsApi} from "../../services/VscsApi";
import ReligionVenueCard from "../../containers/vscs/ReligionVenueCard";
import {useInterval, useMount} from "ahooks";
import DefaultVideoCard from "../../components/common/DefaultVideoCard";
import {ValueUtils} from "../../utils/ValueUtils";
import moment from "moment";
const {Text} = Typography

const VscsReligionVenuePage = () => {
    const [searchParams] = useSearchParams()
    const venueId = searchParams.get("id")

    const [venue, setVenue] = useState({})
    const [cameras, setCameras] = useState([])
    const [cameraSpan, setCameraSpan] = useState(12)
    const [faces, setFaces] = useState([])
    const [venues, setVenues] = useState([])

    const requestVenue = () => {
        VscsApi.venue(venueId)
            .onSuccess(setVenue)
    }

    const requestCameras = () => {
        VscsApi.venueCameras(venueId)
            .onSuccess(data => {
                setCameras([...data])
                setCameraSpan(data.length > 1 ? 12 : 24)
            })
    }

    const requestFaces = () => {
        VscsApi.venueRealtimeFaces(venueId)
            .onSuccess(setFaces)
    }

    const requestPersons = () => {
        VscsApi.flowPerson(moment(), moment(), null, null, venueId)
            .onSuccess(setVenues)
    }

    useInterval(() => {
        requestFaces()
    }, 2000)

    useInterval(() => {
        requestPersons()
    }, 10000)


    useMount(() => {
        requestVenue()
        requestCameras()
        requestFaces()
        requestPersons()
    })

    const handlePersonClick = (person) => {
        window.open('/#/vscs/person/timeline?id=' + person.id)
    }

    return (
        <>
            <Row>
                <Col xl={3} xs={0}>
                    <ReligionVenueCard
                        cardStyle={{height: "100%"}}
                        hoverable={false}
                        imageUrl={venue.imageUrl}
                        name={venue.name}
                        religion={venue.properties?.religion}
                        region={venue.properties?.region?.name}
                    />
                </Col>
                <Col xl={cameras.length < 5 ? 21 : 18} xs={24}>
                    <Card size="small" style={{height: "100%"}}>
                        {
                            cameras.length ? <Row>
                                {
                                    cameras.map(c => <Col xs={24} md={cameras.length > 1 ? 12 : 24}>
                                        <DefaultVideoCard src={c.hlsUrl} title={c.name}/>
                                    </Col>)
                                }
                            </Row> : <Empty description="未配置相机" />
                        }
                    </Card>
                </Col>
                <Col xl={cameras.length < 5 ? 24 : 5} xs={24}>
                    <Card size="small">
                        <h1>今日人员</h1>
                        <Space direction="vertical" split={<Divider/>}>
                            {
                                venues.map(venue =>
                                    <div>
                                        <h4>{venue.name} | {venue.properties?.region} | {venue?.properties?.persons?.length ?? 0}人</h4>
                                        <Space wrap>
                                            {
                                                venue?.properties?.persons?.map(person =>
                                                    <Card size="small"
                                                          hoverable
                                                          style={{width: 128}}
                                                          onClick={() => handlePersonClick(person)}
                                                          cover={<Image
                                                              height={101}
                                                              preview={false}
                                                              src={person.properties?.face.imageUrl}
                                                          />}>
                                                        <Text style={{
                                                            fontSize: 13,
                                                            margin: 0
                                                        }}>#{person.id}</Text>
                                                    </Card>)
                                            }
                                        </Space>
                                    </div>
                                )
                            }
                        </Space>
                        <Divider/>
                        <h1>过脸记录</h1>
                        <Space wrap>
                            {
                                faces.map(f => <Card size="small"
                                                     style={{width: 70}}
                                                     cover={<Image
                                                         height={70}
                                                         style={{objectFit: 'cover'}}
                                                         src={f.imageUrl}
                                                     />}>
                                    <Tooltip title={ValueUtils.formatDateOrEmpty(f.appearTime, "YYYY-MM-DD HH:mm:ss")}>
                                        <span>{ValueUtils.getMomentOrNull(f.appearTime)?.fromNow()}</span>
                                    </Tooltip>
                                </Card>)
                            }
                        </Space>
                    </Card>
                </Col>
            </Row>
        </>
    )
}

export default VscsReligionVenuePage